export const SettingsItem = ({
  className = "",
  children = null,
  title = "",
}) => (
  <div className={className}>
    {title ? <h2 className="font-sans text-4xl mb-4">{title}</h2> : null}
    {children}
  </div>
);
